<div *ngIf="!isHidden" class="cv-quick-date-range-control-wrapper">
    <div class="d-flex" *ngIf="isInitialized && !config.isCxOne">
        <div class="quick-date-main d-flex ml-2 mb-2" role="button" (click)="onMainClick()">
            <p class="m-0">{{ selectedDateRange?.displayNameOrCustomDates }}</p>
            <svg class="icon-12 ml-2 my-auto"><use href="../App_Themes/clearview-default/icons/utility/arrow-down.svg#arrow-down"></use></svg>
        </div>
    </div>
    
    <div class="quick-date-container position-relative"></div>
    <div class="quick-date-dropdown-holder position-absolute" *ngIf="showDropDown">
        <div *ngIf="!config.isCxOne" class="quick-date-dropdown-PM">
            <!-- Days -->
            <div class="quick-date-small-container" *ngIf="dayDateRanges?.length > 0">
                <div class="quick-date-header" cvLocalizedText langSection="Common" langKey="Days">Days</div>
                <p class="quick-date-option"
                *ngFor="let dateRange of dayDateRanges" [class.selected]="(!showCustom && dateRange.displayName === selectedDateRange.displayName)"
                (click)="onDateRangeSelected(dateRange)">
                {{ dateRange.displayName }}
                </p>
            </div>
            <!-- Weeks -->
            <div class="quick-date-small-container" *ngIf="weekDateRanges?.length > 0">
                <div class="quick-date-header" cvLocalizedText langSection="Common" langKey="Weeks">Weeks</div>
                    <p class="quick-date-option"
                    *ngFor="let dateRange of weekDateRanges" [class.selected]="(!showCustom && dateRange.displayName === selectedDateRange.displayName)"
                    (click)="onDateRangeSelected(dateRange)">
                    {{ dateRange.displayName }}
                </p>
            </div>
            <!-- Months -->
            <div class="quick-date-small-container" *ngIf="monthDateRanges?.length > 0">
                <div class="quick-date-header" cvLocalizedText langSection="Common" langKey="Months">Months</div>
                    <p class="quick-date-option"
                    *ngFor="let dateRange of monthDateRanges" [class.selected]="(!showCustom && dateRange.displayName === selectedDateRange.displayName)"
                    (click)="onDateRangeSelected(dateRange)">
                    {{ dateRange.displayName }}
                </p>
            </div>
            <!-- Quarters -->
            <div class="quick-date-small-container" *ngIf="quarterDateRanges?.length > 0">
                <div class="quick-date-header" cvLocalizedText langSection="Common" langKey="Quarters">Quarters</div>
                <p class="quick-date-option"
                    *ngFor="let dateRange of quarterDateRanges" [class.selected]="(!showCustom && dateRange.displayName === selectedDateRange.displayName)"
                    (click)="onDateRangeSelected(dateRange)">
                    {{ dateRange.displayName }}
                </p>
            </div>
            <!-- Years -->
            <div id="year-date-ranges" class="quick-date-small-container" *ngIf="yearDateRanges?.length > 0">
                <div class="quick-date-header" cvLocalizedText langSection="Common" langKey="Years">Years</div>
                <p class="quick-date-option"
                    *ngFor="let dateRange of yearDateRanges" [class.selected]="(!showCustom && dateRange.displayName === selectedDateRange.displayName)"
                    (click)="onDateRangeSelected(dateRange)">
                    {{ dateRange.displayName }}
                </p>
            </div>
            <!-- Custom -->
            <p class="quick-date-option"
                *ngIf="customDateRange?.displayName"
                [class.selected]="(showCustom)"
                (click)="onDateRangeSelected(customDateRange)">
                {{ customDateRange.displayName }}
            </p>
        </div>
        <!-- CXOne -->
        <div *ngIf="config.isCxOne">
            <div class="quick-date-dropdown">
                <p class="quick-date-option"
                    *ngFor="let dateRange of availableDateRanges" [class.selected]="(!showCustom && dateRange.displayName === selectedDateRange.displayName) || (showCustom && dateRange.name === 'Custom...')"
                    (click)="onDateRangeSelected(dateRange)">
                    {{ dateRange.displayName }}
                </p>
            </div>
            <div class="quick-date-custom modal-content" *ngIf="showCustom">
                <div class="modal-header border-0">
                    <div class="subtitle-2 mt-1">Choose Date Range</div>
                    <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail modal-close" (click)="showCustom = false">
                        <svg class="icon-16"><use href='../../App_Themes/clearview-default/icons/utility/close.svg#close'></use></svg>
                    </button>
                  </div>
                  <div class="modal-body p-0">
                    <cv-baremetrics-calendar
                        class="d-block daterange daterange--double"
                        [startDate]="selectedStartDate"
                        [endDate]="selectedEndDate"
                        (dateChanged)="onCustomDateRangeChanged($event)"
                        [required]="true"
                    ></cv-baremetrics-calendar>
                    <div class="color-redRyder mt-2 font-size-12" *ngIf="maxDaysError">{{ maxDaysError }}</div>
                  </div>
                  <div class="modal-footer border-0 mt-0">
                    <button type="button" class="btn btn-primary" [disabled]="!!maxDaysError" (click)="onCustomDateRangeConfirmed()" cvLocalizedText langSection="Common" langKey="OK">OK</button>
                  </div>
            </div>
        </div>
    </div>

    <!-- Custom Date Range -->
    <div class="quick-date-custom-PM modal-content" *ngIf="showCustom && !config.isCxOne">
        <div class="modal-header border-0">
            <div class="subtitle-2 mt-1" cvLocalizedText langSection="Common" langKey="Choose_Date_Range">Choose Date Range</div>
            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail modal-close" (click)="showCustom = false">
                <svg class="icon-16"><use href='../../App_Themes/clearview-default/icons/utility/close.svg#close'></use></svg>
            </button>
            </div>
            <div class="modal-body p-0">
            <cv-baremetrics-calendar
                class="d-block daterange daterange--double"
                [startDate]="selectedStartDate"
                [endDate]="selectedEndDate"
                (dateChanged)="onCustomDateRangeChanged($event)"
                [required]="true"
            ></cv-baremetrics-calendar>
            <div class="color-redRyder mt-2 font-size-12" *ngIf="maxDaysError">{{ maxDaysError }}</div>
            </div>
            <div class="modal-footer border-0 mt-0">
            <button type="button" class="btn btn-primary" [disabled]="!!maxDaysError" (click)="onCustomDateRangeConfirmed()" cvLocalizedText langSection="Common" langKey="OK">OK</button>
            </div>
    </div>
    
    <cv-cxone-date-range-selector *ngIf="isInitialized && config.isCxOne && changeAllowed"
        style="max-width: 208px;"
        class="d-block ml-1 my-auto"
        dropdownContainer=".custom-picker"
        [selectedDateRange]="selectedDateRange"
        [availableDateRanges]="availableDateRanges"
        (selectedDateRangeChange)="onDateRangeSelected($event)"
        [pageName]="pageName"
        [maxDays]="maxDays"
        [minDate]="minDate"
    ></cv-cxone-date-range-selector>
</div>
